<div fxLayout>
  <main fxFlex [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <div fxLayout fxLayoutAlign="start start" class="keys__header">
      <h2 fxFlex fxLayout fxLayoutAlign="start center" fxLayoutGap="10px">
        <img class="clickable" [routerLink]="['../']" src="/assets/iconography/arrow-left-rose.svg" />
        <span fxFlex>API access</span>
      </h2>

      <sbnb-save-indicator [saveStatus]="saveStatus"></sbnb-save-indicator>
    </div>

    <section class="access-tokens" fxLayout fxLayout.lt-md="column" fxLayoutGap.lt-md="40px" fxLayoutGap="80px">
      <div class="left-container" fxFlex="250px" fxFlex.lt-md="auto" fxLayout="column" fxLayoutGap="40px">
        <div class="left-intro" fxLayout="column" fxLayoutGap="16px">
          <h3>Introduction</h3>
          <span>
            You can use access tokens to interact with your Hospitable account programmatically via our Public API V2.
            These access tokens are intended for
            <strong>personal use</strong>
            and should not be shared with 3rd parties for the purpose of configuring an integration.
          </span>
          <sbnb-button type="secondary" size="mini">
            <a (click)="openIntercomHelp('8609392')">Learn more</a>
          </sbnb-button>
        </div>
      </div>

      <div fxFlex style="max-width: 800px">
        <div fxLayout style="margin-bottom: 24px">
          <div fxLayout fxLayoutAlign="end center" class="w-full">
            <sbnb-button *ngIf="!loadingTokens && accessTokens?.length > 0" [loading]="creatingToken" size="mini" (clicked)="addAccessToken()">
              + Add new
            </sbnb-button>
          </div>
        </div>

        <div *ngIf="loadingTokens">
          <mat-spinner diameter="24"></mat-spinner>
        </div>

        <ng-container *ngIf="!loadingTokens">
          <div *ngIf="!accessTokens || accessTokens.length === 0">
            <sbnb-no-items
              *ngIf="!accessTokens || accessTokens.length === 0"
              text="No access tokens yet"
              subtext="You haven't created any access tokens yet. You can create the first one with the button below."
              [buttons]="[{ id: 'new', label: '+ Add new', size: 'mini' }]"
              (button)="addAccessToken()"></sbnb-no-items>
          </div>

          <ng-container *ngIf="accessTokens?.length > 0">
            <div
              *ngFor="let token of accessTokens"
              class="webhook__container"
              fxLayout
              fxLayoutGap="24px"
              fxLayoutAlign="start center">
              <div class="key__item">
                <div class="key__item-padding">
                  <div fxLayout style="margin-bottom: 20px">
                    <div fxFlex fxLayout="column" fxLayoutGap="4px">
                      <h3 class="nomargin">
                        <input
                          #nameInput
                          [matTooltip]="'A label for this token'"
                          maxlength="25"
                          autocomplete="off"
                          class="input__borderless"
                          type="text"
                          [style.width.px]="nameInput.value.length * 13"
                          [(ngModel)]="token.name"
                          (change)="updateAccessToken(token)" />
                      </h3>
                    </div>

                    <img
                      class="clickable delete__icon"
                      [matTooltip]="'Delete token'"
                      (click)="deleteAccessTokenPrompt(token)"
                      src="/assets/iconography/delete-smoke.svg" />
                  </div>

                  <div class="key__item-field">
                    <strong>Access token:</strong>
                    <span class="key__item-value ellipsis" [class.masked]="!token.secret" style="padding-right: 24px">
                      {{ token.secret || '●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●' }}
                    </span>
                    <span
                      *ngIf="token.secret; else revealTokenTemplate"
                      class="key__item-copy"
                      ngxClipboard
                      [cbContent]="token.secret"
                      (click)="tokenCopied(token)">
                      <img
                        *ngIf="!token.recently_copied"
                        class="copy-icon"
                        [@fadeInOut]
                        src="/assets/iconography/copy-grass.svg"
                        alt="Copy"
                        matTooltip="Copy Token" />
                      <sbnb-icon
                        icon="check"
                        *ngIf="token.recently_copied"
                        class="copy-icon"
                        [@fadeInOut]
                        [size]="21"></sbnb-icon>
                    </span>

                    <ng-template #revealTokenTemplate>
                      <span class="key__item-copy" (click)="revealToken(token.id)">
                        <img
                          class="copy-icon"
                          [@fadeInOut]
                          src="/assets/iconography/eye-grass.svg"
                          alt="Reveal"
                          matTooltip="Reveal Token" />
                      </span>
                    </ng-template>
                  </div>
                  <div class="mt-4 flex justify-between text-smoke-darker text-sm">
                    <span class="key__item-value" [matTooltip]="token.last_used_at | date: 'medium'">
                      Last used: {{ token.last_used_label ? token.last_used_label : 'Never' }}
                    </span>

                    <div class="flex items-center gap-2">
                      <span
                        class="key__item-value"
                        *ngIf="!token.is_expired"
                        [matTooltip]="token.expires_at | date: 'medium'">
                        Expires: {{ token.expires_at_label }}
                      </span>
                      <span
                        *ngIf="token.is_expired"
                        class="p-2 py-1 text-xs font-medium bg-rose-lighter text-rose-darker rounded flex items-center gap-1"
                        [matTooltip]="'Expired ' + (token.expires_at | date: 'medium')">
                        <sbnb-icon icon="alert-triangle" [size]="14"></sbnb-icon>
                        Expired
                      </span>
                    </div>
                  </div>
                </div>

                <div
                  fxLayout
                  fxLayoutAlign="start center"
                  fxLayoutGap="24px"
                  fxLayout.lt-lg="column"
                  fxLayoutAlign.lt-lg="start start"
                  fxLayoutGap.lt-lg="6px"
                  class="key__item-scope">
                  <strong fxFlex>Token permissions</strong>

                  <div fxLayoutGap="8px">
                    <mat-checkbox
                      [checked]="token.scopes.indexOf(ApiAccessTokenScope.Read) > -1"
                      (change)="updateAccessTokenScope(token, ApiAccessTokenScope.Read, $event)">
                      Read
                    </mat-checkbox>
                    <mat-checkbox
                      [checked]="token.scopes.indexOf(ApiAccessTokenScope.Write) > -1"
                      (change)="updateAccessTokenScope(token, ApiAccessTokenScope.Write, $event)">
                      Write
                    </mat-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </div>
    </section>
  </main>
</div>
